<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodawanie numeru zamówienia
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="orderNumber"
                                :error-messages="orderNumberErrors"
                                label="Numer zamówienia"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    :loading="actionLoading"
                    @click="saveOrderNumber()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'AddOrderNumberDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            orderNumber: null,
            actionLoading: false
        }
    },
    validations: {
        orderNumber: { required }
    },
    computed: {
        orderNumberErrors() {
            const errors = []

            if (!this.$v.orderNumber.$dirty) return errors
            !this.$v.orderNumber.required && errors.push('Proszę podać numer zamówienia.')

            return errors
        },
    },
    methods: {
        saveOrderNumber() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.$emit('on-confirm', this.orderNumber)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.orderNumber = null
            }, 500)
            this.$v.$reset()
            this.actionLoading = false
            this.$emit('on-close')
        },
    }
}
</script>

